import React from 'react'
import { withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import { clientAction } from '../reducers/restApi'
import withWidth from '@material-ui/core/withWidth'
import ArticleTextSegment, { MARKDOWN } from '../components/articleSegments/ArticleTextSegment'
import ArticlePointMapSegment, { POINT_MAP } from '../components/articleSegments/ArticlePointMapSegment'
import { BURDEN_TREE } from '../components/articleSegments/BurdenTreeSegment'
import BurdenTreeSummary from '../components/articleSegments/BurdenTreeSummary'

const styles = theme => ({
  // root: {
  //   width: '100%',
  //   marginTop: theme.spacing.unit * 3,
  //   overflowX: 'auto',
  //   // maxWidth: "800px",
  // },
  table: {
    // minWidth: 700,
  },
  title: {
    flex: '0 0 auto',
    margin: '10px'
  },
  tableCell: {
    whiteSpace: 'nowrap',
    padding: '3px 16px 3px 14px'
  },
  locationCell: {
    padding: '3px 16px 3px 14px'
  },
  dateCell: {
    width: '70px',
    padding: '3px 16px 3px 14px'
  },
  refreshButton: {
    color: 'green',
    width: '100%',
    height: '100%'
  },
  formElement: {
    width: '100%'
  },
  tablePaper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  formContainer: {
    margin: 10
  },
  spacingContainer: {
    padding: theme.spacing(2),
  },
  addContainer: {
    flexDirection: 'row-reverse',
    flex: 1,
    textAlign: 'right',
    paddingRight: '1em'
  },
  deleteButton: {
    backgroundColor: 'red'
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  tileImage: {},
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    // height: '100%',
    maxWidth: 1280,
    margin: '0px auto',
    padding: 5,
    position: 'absolute',
    top: 64, bottom: 0, left: 0, right: 0,

  },
  header: {
    margin: '15px auto',
    padding: '20px 20px',
    width: '100%'
  },
  segment: {
    width: '100%',
    margin: '10px 0',
  },
  gridList: {
    width: '100%',
    height: '100%',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  titleBar: {
    width: '100%'
  }

})

class ArticleDetails extends React.Component {
  state = {
    dialogOpen: false,
    directoryDialogOpen: false,
    dialogConfirmationOpen: false,
    dialogDirectoryConfirmationOpen: false,
    selectedId: null,
    directorySelectedId: null,
    path: []
  }

  componentDidMount () {
    this.props.listArticle()
  }

  handleClose () {
    this.setState({ dialogOpen: false, selectedId: null })
  }

  handleEdit (id) {
    let item = this.props.files.data[id].instance
    this.props.initializeForm(item)
    this.setState({ dialogOpen: true, selectedId: id })
  }

  handleAdd () {
    this.props.initializeForm({})
    this.setState({ dialogOpen: true, selectedId: null })
  }

  selectItem (tile) {
    if (tile.mimetype === undefined) {
      let newPath = this.state.path.slice()

      if (tile.name === '..') {
        if (newPath.length >= 0) {
          newPath.pop()
        }
      } else {
        newPath.push(tile.name)
      }
      this.setState({ path: newPath })
    } else {
      // file
      window.open(tile.url, '_blank')
    }
  }

  render () {
    let {
      classes,
      // files,
      // directory,
      article,
      match
      // ...props
    } = this.props

    let o = article && article.data && article.data[match.params.article_id]
    o = o && o.instance

    return o ? (<div className={classes.root}>
      {/*<Paper className={classes.header}>*/}
      {/*<Typography variant={'h1'}>*/}
      {/*  {o.title}*/}
      {/*</Typography>*/}
      {/*<div dangerouslySetInnerHTML={{ __html: o.formatted_blurb }}></div>*/}
      {/*</Paper>*/}
      {o.children.map(child => {
        switch (child.item_type) {
          case  MARKDOWN:
            return <ArticleTextSegment child={child} key={child.id}
                                       article={o}

                                       className={classes.segment}/>
          case  POINT_MAP:
            return <ArticlePointMapSegment child={child} key={child.id}
                                           article={o}
                                           className={classes.segment}
            />
          case BURDEN_TREE:
            return <BurdenTreeSummary child={child} key={child.id}
                                      article={o}
                                      className={classes.segment}
            />
          default:
            return <div style={{ color: 'red' }} className={classes.segment}>
              Unsupported ITEM type
            </div>

        }
      })}

    </div>) : 'Loading'
  }
}

export default withWidth()(withStyles(styles)(connect(
  (state) => (
    {
      schema: state.schema.schema,
      article: state.restApi.article,
    }
  ),

  (dispatch) => ({
    listArticle: () => dispatch(clientAction(['article', 'list'])),
  })
  )(ArticleDetails)
))

